import React from 'react';
import BottomNav from '../components/BottomNav';
import MembershipCard from '../components/MembershipCard';
import ServiceCard from '../components/ServiceCard';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();

  // Check if user has Gold or higher membership
  const isGoldOrHigher = user && ['Gold', 'Platinum', 'LGC', 'Privé', 'Admin'].includes(user.membershipLevel);

  const services = [
    { title: 'IBV Gold Online', link: '/gold-online' },
    { title: 'IBV Vaults Online', link: '/vaults' },
    { title: 'IBV Gold Bullion Insurance', link: '/bullion-insurance' },
    { title: 'IBV Privé Private Wealth Club', link: '/prive-lounge'},
    { title: 'IBV Privé Lounge & Bakery Online', link: '/prive-wealth-club'  },
    { title: 'IBV Curated Wealth & Luxury Events', link: '/news' },
    { title: 'IBV Gift of Gold Club & luxury Brand Partners', link: '/gift-of-gold' },
    { title: 'London VIP Protect & Chauffeur Drive', link: '/concierge' },
    { title: 'IBV Luxury Travel & Africa Safari Adventures', link: '/travel' },
    { title: 'IBV Super Car Club Fleet Rewards', link: '/supercar-club' },
    { title: 'IBV Leading Ladies Events', link: '/leading-ladies-circle' },
    { title: 'IBV AI Tutor / Future Leaders', link: '/ai-tutor' },
    { title: 'IBV Global Wealth Advisory', link: '/wealth-advisory' },
    { title: 'Euro Africa Insurance Sales Team', link: '/insurance-wealth-protection', locked: !isGoldOrHigher, requiredTier: 'Gold' },
    { title: 'IBV Bullion Finance / IBV Islamic Finance Brokers', link: '/bullion-exchange', locked: !isGoldOrHigher, requiredTier: 'Gold' },
    { title: 'IBV Property Investment Opportunities', link: '/prime-real-estate', locked: !isGoldOrHigher, requiredTier: 'Gold' }
  ];

  const locations = ['London', 'Dubai', 'South Africa'];

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <div className="top-logo" style={{textAlign: 'center', marginBottom: '1rem'}}>
          <img src="/images/IBVlogo.png" alt="IBV Wealth Club" style={{maxWidth: '150px', height: 'auto'}} />
        </div>

        <div className="location-nav">
          {locations.map((location) => (
            <button key={location} className="location-btn">{location}</button>
          ))}
        </div>

        <div className="dashboard-heading">
          <div className="underline"></div>
        </div>

        <MembershipCard />

        <div className="service-grid">
          {services.map((service, index) => (
            <ServiceCard 
              key={index} 
              title={service.title} 
              link={service.link}
              locked={service.locked}
              requiredTier={service.requiredTier}
            />
          ))}
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default Dashboard;
